import { faTimes } from "@fullscript/pro-light-svg-icons";

import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";
import { Size } from "@shared/types/sizes";

import type { IconButtonProps } from "../IconButton";
import { IconButton } from "../IconButton";

import * as styles from "./CloseButton.styles";

interface Props extends Omit<IconButtonProps, "type" | "isColor" | "isCircular"> {
  /**
   * If the placement of the close button should be absolutely positioned
   */
  absolutePosition?: "topRight";
  /**
   * Specific variant styles/position used in modals
   */
  isModal?: boolean;
}

/**
 * @deprecated Use `IconButton` from `@fullscript/aviary-web` with the `faTimes` icon instead.
 */
const CloseButton = ({
  intention = "textSystem",
  size = Size.XSMALL,
  isModal,
  absolutePosition,
  ...rest
}: Props) => {
  const iconSizer = () => {
    if (!size) return "1x";
    switch (size) {
      case Size.XSMALL:
        return "lg";
      case Size.SMALL:
        return "2x";
      case Size.LARGE:
        return "3x";
      default:
        break;
    }
  };

  const closeStyles = [
    absolutePosition && styles.position[absolutePosition],
    isModal && styles.modalVersion,
  ];

  return (
    <IconButton
      analyticsName="dismiss"
      css={closeStyles}
      isColor="system"
      size={size}
      intention={intention}
      {...rest}
    >
      <FontAwesomeIcon icon={faTimes} size={iconSizer()} />
    </IconButton>
  );
};

export { CloseButton };
